"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyQuestion1ToJSON = exports.SurveyQuestion1FromJSONTyped = exports.SurveyQuestion1FromJSON = exports.instanceOfSurveyQuestion1 = void 0;
var runtime_1 = require("../runtime");
var SurveyOption1_1 = require("./SurveyOption1");
var SurveySelectionType_1 = require("./SurveySelectionType");
/**
 * Check if a given object implements the SurveyQuestion1 interface.
 */
function instanceOfSurveyQuestion1(value) {
    var isInstance = true;
    isInstance = isInstance && "selectionType" in value;
    isInstance = isInstance && "questionType" in value;
    isInstance = isInstance && "questionText" in value;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
exports.instanceOfSurveyQuestion1 = instanceOfSurveyQuestion1;
function SurveyQuestion1FromJSON(json) {
    return SurveyQuestion1FromJSONTyped(json, false);
}
exports.SurveyQuestion1FromJSON = SurveyQuestion1FromJSON;
function SurveyQuestion1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'selectionType': (0, SurveySelectionType_1.SurveySelectionTypeFromJSON)(json['selection_type']),
        'questionType': json['question_type'],
        'questionText': json['question_text'],
        'secondaryText': !(0, runtime_1.exists)(json, 'secondary_text') ? undefined : json['secondary_text'],
        'options': (json['options'].map(SurveyOption1_1.SurveyOption1FromJSON)),
        'randomizeOptions': !(0, runtime_1.exists)(json, 'randomize_options') ? undefined : json['randomize_options'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'marketCode': !(0, runtime_1.exists)(json, 'market_code') ? undefined : json['market_code'],
        'languageCode': !(0, runtime_1.exists)(json, 'language_code') ? undefined : json['language_code'],
        'surveyMarketId': !(0, runtime_1.exists)(json, 'survey_market_id') ? undefined : json['survey_market_id'],
        'surveyLanguageId': !(0, runtime_1.exists)(json, 'survey_language_id') ? undefined : json['survey_language_id'],
    };
}
exports.SurveyQuestion1FromJSONTyped = SurveyQuestion1FromJSONTyped;
function SurveyQuestion1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'selection_type': (0, SurveySelectionType_1.SurveySelectionTypeToJSON)(value.selectionType),
        'question_type': value.questionType,
        'question_text': value.questionText,
        'secondary_text': value.secondaryText,
        'options': (value.options.map(SurveyOption1_1.SurveyOption1ToJSON)),
        'randomize_options': value.randomizeOptions,
        'language': value.language,
        'market_code': value.marketCode,
        'language_code': value.languageCode,
        'survey_market_id': value.surveyMarketId,
        'survey_language_id': value.surveyLanguageId,
    };
}
exports.SurveyQuestion1ToJSON = SurveyQuestion1ToJSON;
